"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getStorage;
exports.storageTypes = void 0;

var _browserStorage = _interopRequireDefault(require("./storageTypes/browserStorage"));

var _memoyStorage = _interopRequireDefault(require("./storageTypes/memoyStorage"));

var storageTypes = {
  SESSION: 'session',
  MEMORY: 'memory',
  LOCAL: 'local'
};
exports.storageTypes = storageTypes;

function getStorage(storageType) {
  var storage = null;

  switch (storageType) {
    case storageTypes.LOCAL:
    case storageTypes.SESSION:
      storage = (0, _browserStorage["default"])(storageType);
      break;

    case storageTypes.MEMORY:
    default:
      storage = (0, _memoyStorage["default"])();
  }

  if (!storage) {
    return (0, _memoyStorage["default"])();
  }

  return storage;
}